import table from './table';
import { transformLocations, transformInstructor, transformAll } from './transform';

export default {
  table,
  get: {
    name: 'activityLogs',
    path: 'logs',
    transform: transformAll,
    defaultValue: []
  },
  location: {
    placeholder: 'Location',
    component: 'select',
    async: true,
    options: [{ id: 'all', label: 'All' }],
    get: {
      path: 'branches',
      transform: transformLocations,
      defaultValue: [],
      memoize: false
    }
  },
  instructors: {
    name: 'logsInsrtuctors',
    path: 'users/total_instructors/0',
    transform: transformInstructor,
    defaultValue: []
  }
};
